export interface VendorApiSessionSettings {
  /**
   * The session timeout in seconds to be used when the server provides no session timeout. When 0 (zero) is set, the session will never expire.
   * Please note, all clients can detect and handle responses indicating session expiration.
   */
  defaultSessionTimeoutSec?: number;
  /**
   * Max count of failed attempts to refresh the session when the session is already expired. Please note,
   * the `failedSessionRefreshCountMax` is ignored until the session has not expired yet.
   */
  failedSessionRefreshCountMax?: number;
  /**
   * The exponential backoff is applied when a session refresh fails. The `failedSessionRefreshWaitTimeBaseSec` is a base time in seconds
   * used for the wait time calculation.
   */
  failedSessionRefreshWaitTimeBaseSec?: number;
  /**
   * Max wait time in seconds between two consequent session refresh attempts.
   */
  failedSessionRefreshWaitTimeMaxSec?: number;
  /**
   * When a session has its expiration, the client has to refresh it some time before it expires.The `sessionRefreshSafetyFactorPct` sets a number
   * of percent of the session timeout when the first attempt to refresh the session should be sent.
   */
  sessionRefreshSafetyFactorPct?: number;
}
